module.exports = __webpack_public_path__ + "resources/icon-status-online.c6d71e9fc0c59a2e.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/label/img/icon-status-online.png
// module id = 555
// module chunks = 0 1 2 3